import * as React from 'react';
import * as styles from './styles.css';

export interface IContentSectionProps {
  children: React.ReactNode | React.ReactNode[];
}

export function ContentSection({ children }: IContentSectionProps) {
  return <div className={styles['container']}>{children}</div>;
}
